module.exports = __webpack_public_path__ + "static/logo-e62d134bf55bddc2964ff553e9de9476.png";